import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { feedback } from "./appShell";
import { IconChevronLeft, IconSortie, IconWarning } from "./icons";
import { formatDate } from "./statuts";
import "./styles.css";

// const API_URL = "https://localhost:8443/api/assets/sortie";
const API_URL = "https://app.bicadev.com/api/assets/sortie";

export default function ScanSortiePage() {
  const navigate = useNavigate();

  const [numero, setNumero] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [flash, setFlash] = useState(false);

  const inputRef = useRef(null);
  const flashTimer = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    return () => clearTimeout(flashTimer.current);
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSortie();
  };

  const handleSortie = async () => {
    if (!numero) return;

    setLoading(true);
    setError("");
    setData(null);

    try {
      const response = await axios.post(`${API_URL}/${numero}`);
      setData(response.data);

      feedback();
      setFlash(true);
      clearTimeout(flashTimer.current);
      flashTimer.current = setTimeout(() => setFlash(false), 450);
    } catch {
      setError("Impossible d'enregistrer la sortie du rouleau");
    } finally {
      setLoading(false);
      setNumero("");
      inputRef.current?.focus();
    }
  };

  return (
    <div>
      <div className="page-header">
        <button className="btn-back" onClick={() => navigate("/")}>
          <IconChevronLeft />
          Retour
        </button>

        <div className="page-header-title">
          <IconSortie size={19} color="var(--accent-red)" />
          Scan Sortie Rouleau
        </div>
      </div>

      <div className="scan-body">
        <div className="scan-field">
          {/* Voile rouge : la sortie est un mouvement destructif, on la
              distingue visuellement de l'entrée. */}
          <div className={`scan-flash red ${flash ? "on" : ""}`} />
          <input
            ref={inputRef}
            type="text"
            inputMode="none" /* Prevents virtual keyboard from popping up if hardware scanner is used */
            placeholder="Scanner ou saisir le numéro..."
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            onKeyDown={handleKeyPress}
          />
        </div>

        {loading && (
          <div className="status-line">
            <span className="spinner spinner--red" />
            Traitement en cours...
          </div>
        )}

        {error && (
          <div className="alert-error">
            <IconWarning />
            {error}
          </div>
        )}

        {data && (
          <div className="result-card">
            <div className="pill pill--success">Sortie du stock enregistrée</div>

            {data.dateSortie && (
              <div className="result-date">
                Sortie le : {formatDate(data.dateSortie)}
              </div>
            )}

            <h2 className="roll-number">{data.numeroRouleau}</h2>

            <div className="info-grid">
              <div><span>Métrage</span>{data.metrage} m</div>
              <div><span>Poids</span>{data.poids} kg</div>
              <div><span>Laize</span>{data.laize}</div>
              <div><span>Nuance</span>{data.nuance}</div>
            </div>

            <div className="divider" />

            <div className="info-grid">
              <div><span>Tissu</span>{data.tissuNom}</div>
              <div><span>Import</span>{data.numeroImport}</div>
              <div className="full"><span>Fournisseur</span>{data.fournisseurImport}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
